import { FC, useEffect, useState } from "react";
import styles from "../Whale.module.scss";
import { useForm } from "react-hook-form";
import { shortWallet } from "@utils/shortWallet";
import Tracked from "@components/shared/modals/Tracked";
import { useModal } from "@hooks/useModal";

const WalletButton: FC = () => {
    const { watch, handleSubmit } = useForm();
    const [selectedWallet, setSelectedWallet] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [handleOpen, handleHide] = useModal(setIsModalVisible);

    useEffect(() => {
        const subscription = watch(() => handleSubmit((data) => console.log(data))());
        return () => subscription.unsubscribe();
    }, []);

    return (
        <button onClick={isModalVisible ? handleHide : handleOpen} className={styles.filter}>
            <span>
                Mega whale <span className={styles.wallet}>{shortWallet(selectedWallet)}</span>
            </span>
            <img width={24} height={24} src="/images/swap/down.svg" alt="" />
            <Tracked
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
                setSelectedWallet={setSelectedWallet}
            />
        </button>
    );
};
export default WalletButton;
